<template>
  <div class="page">
    <div class="card">
      <div class="header">
        <div class="description">
          <h2 class="title">Status do Sistema</h2>
          <p class="subtitle">Monitore o status dos serviços e incidentes reportados.</p>
        </div>

        <card-actions>
          <button class="btn btn-primary -sm" @click="fetchIncidents" :disabled="loading">
            Atualizar<ion-icon name="refresh" :class="{ 'animate-spin': loading }"></ion-icon>
          </button>
        </card-actions>
      </div>

      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      <div class="body">
        <active-incidents />
        <endpoints-status />
        <resolved-incidents />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CardActions from '../../support/components/card/CardActions.vue';
import ActiveIncidents from '../components/ActiveIncidents.vue';
import EndpointsStatus from '../components/EndpointsStatus.vue';
import ResolvedIncidents from '../components/ResolvedIncidents.vue';

export default {
  name: 'Status',

  components: {
    CardActions,
    ActiveIncidents,
    EndpointsStatus,
    ResolvedIncidents,
  },

  computed: {
    ...mapState({
      loading: (state) => state.status.loading,
      error: (state) => state.status.error,
    }),
  },

  methods: {
    ...mapActions({
      fetchIncidents: 'status/fetchIncidents',
      fetchEndpoints: 'status/fetchEndpoints',
    }),
  },

  mounted() {
    this.fetchIncidents();
    this.fetchEndpoints();
  },
};
</script>

<style lang="scss" scoped>
.page {
  > .card {
    > .body {
      padding: 2rem;
    }
  }
}

.error-message {
  @apply bg-red-50;
  @apply text-red-800;
  @apply p-4;
  @apply rounded-md;
  @apply mb-4;
  @apply text-sm;
  @apply flex;
  @apply items-center;
  @apply justify-between;
}
</style>
